module.exports = new __parcel__URL__("switching-tabs.9848ba18.gif").toString();